import {INPSTrendGraph, INPSSummary, INPSStatsSummary} from '@/entities'
import client from '@/api/client'
import qs from 'qs'
import { OfflineCache } from '@/mobile/src/utils/offlinecache'

const offlineCache = new OfflineCache('scorecard')

/*
    Gets the summary depending on the user's
    active filter stored serverside.
*/
export async function getNPSSummary(is_external = 0, time_unit = '', time_value = 0, user_id ?: string, questionType = '') {
    let paramsObj = {is_external} as any
    if (time_unit && time_value) {
        paramsObj = {...paramsObj, time_unit, time_value}
    }
    if (user_id) {
        paramsObj = {...paramsObj, user_id}
    }
    if (questionType) {
        paramsObj = {...paramsObj, questionType}
    }
    const params = qs.stringify(paramsObj)
    return offlineCache.cachedGet<INPSSummary>(client, `/nps/summary?${ params }`)
}
export async function getNPSSummaries(
    is_external = 0,
    time_unit = '',
    time_value = 0,
    filter_by?: string,
    customFieldValue?: string,
    data_points?: number) {
    let paramsObj = {is_external} as any
    if (time_unit && time_value) {
        paramsObj = {...paramsObj, time_unit, time_value}
    }
    if (filter_by) {
        const filterByContent = customFieldValue ?`${filter_by}:${customFieldValue}` : filter_by
        paramsObj = {...paramsObj, filter_by: filterByContent}
    }
    if (data_points) {
        paramsObj = {...paramsObj, data_points}
    }
    const params = qs.stringify(paramsObj)
    return client.get<INPSSummary|INPSSummary[]>(`/nps/summary?${params}`)
}

export async function getNPSTrendGraph(questionType = '') {
    let paramsObj = {}
    if (questionType) {
        paramsObj = {...paramsObj, questionType}
    }
    const params = qs.stringify(paramsObj)
    return await offlineCache.cachedGet<INPSTrendGraph>(client,`/nps/trend-graph?${params}`)
}

export async function getWeeklyNPSTrendGraph(userId?: string) {
    return await offlineCache.cachedGet<INPSTrendGraph>(client, `/nps/` + (userId ? `user/${ userId }/` : ``) + `weekly-trend-graph`)
}

export async function getNPSStatsSummary(questionType = '', time_unit = '', time_value = 0) {
    let paramsObj = {}
    if (questionType) {
        paramsObj = {...paramsObj, questionType}
    }
    if (time_unit && time_value) {
        paramsObj = {...paramsObj, time_unit, time_value}
    }
    const params = qs.stringify(paramsObj)
    return await offlineCache.cachedGet<INPSStatsSummary>(client, `/nps/stats-summary?${params}`)
}

export async function getSentimentTrendGraph(column: string) {
    return await client.get<INPSTrendGraph>(`/nps/sentiment-graph/${column}`)
}
